module.exports = __webpack_public_path__ + "static/img/thumb_2.2de82ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/menu/thumb_2.png
// module id = XhmV
// module chunks = 0